import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHatCowboySide } from '@fortawesome/free-solid-svg-icons/faHatCowboySide';
import type { IconProps } from '../../types';

export function CowboyHatIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Cowboy Hat',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faHatCowboySide}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
